import React from 'react';
import { COLORS,FONTS, FONT_SIZES } from '@bcm/constants';
import { View, Text, StyleSheet, Pressable, Linking } from 'react-native';

import Screens from '../screens/Screens';
import env from '../constants/env';
import Icon from './UI/icon/Icon';
import IconMap from './UI/icon/IconMap';
import GlobalPressable from './UI/button/GlobalPressable';

const Footer = (props) => (
	<View style={styles.container}>
		<View style={styles.rowContainer}>
			<Pressable
				style={styles.pressable}
				onPress={() => props.navigation.navigate(Screens.contact)}
			>
				<Text style={styles.text}>Contact</Text>
			</Pressable>
			<Pressable
				style={styles.pressable}
				onPress={async () => await Linking.openURL(env.SUPPORT_URL)}
			>
				<Text style={styles.text}>Support</Text>
			</Pressable>
			<Pressable
				style={styles.pressable}
				onPress={() => props.navigation.navigate(Screens.privacy)}
			>
				<Text style={styles.text}>Privacy</Text>
			</Pressable>
		</View>
		<View style={styles.rowContainer}>
			<GlobalPressable
				style={styles.downloadContainer}
				onPress={() => Linking.openURL(env.GOOGLE_PLAYSTORE_URL)}
			>
				<View style={styles.downloadIconContainer}>
					<Icon
						icon={IconMap.googlePlaystore}
						size={35}
						color={COLORS.white}
					/>
				</View>
				<Text style={styles.downloadText}>Google Playstore</Text>
			</GlobalPressable>
			<GlobalPressable
				style={styles.downloadContainer}
				onPress={() => Linking.openURL(env.APPLE_APPSTORE_URL)}
			>
				<View style={styles.downloadIconContainer}>
					<Icon
						icon={IconMap.appleAppstore}
						size={35}
						color={COLORS.white}
					/>
				</View>
				<Text style={styles.downloadText}>Apple Appstore</Text>
			</GlobalPressable>
		</View>
		<Text style={styles.text}>
			{`© Copyright ${new Date().getFullYear()}, BurnCam Medical Inc.`}
		</Text>
	</View>
);

const styles = StyleSheet.create({
	container: {
		height: '10vh',
		minHeight: 100,
		width: '100%',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: COLORS.medium
	},
	rowContainer: {
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
	},
	pressable: {
		width: 150,
		borderBottomColor: COLORS.white,
		borderBottomWidth: 1,
		justifyContent: 'center',
		alignItems: 'center',
	},
	text: {
		fontFamily: FONTS.default,
		fontSize: FONT_SIZES.md,
		color: COLORS.white
	},
	downloadContainer: {
		width: 120,
		height: 50,
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
	},
	downloadIconContainer: {
		marginVertical: 7.5,
		marginHorizontal: 10,
	},
	downloadText: {
		fontFamily: FONTS.default,
		fontSize: FONT_SIZES.sm,
		color: COLORS.white
	},
});

export default Footer;